import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-arrow-down",
  templateUrl: "./arrow-down.component.html",
  styleUrls: ["./arrow-down.component.scss"],
})
export class ArrowDownComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
